export const getMissingInfo = (user, insurancesCount = 0) => {
  const errors = {}
  if (user.insured && insurancesCount === 0) {
    errors.insurance = 'Please add your insurance information'
  }
  return errors
}
